import React, { Component, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom/cjs/react-router-dom.min';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import {
  H4,
  IconSpinner,
  ImageVideoPreview,
  InlineTextButton,
  NamedLink,
  Page,
  PrimaryButton,
  SecondaryButton,
} from '../../components';
import { FormattedMessage, useIntl } from 'react-intl';
import { compose } from 'redux';
import FooterComponent from '../FooterContainer/FooterContainer';
import css from './CartPage.module.css';
import { useConfiguration } from '../../context/configurationContext';
import { types as sdkTypes } from '../../util/sdkLoader';
import { PriceMaybe } from '../../components/ListingCard/ListingCard';
import { createSlug } from '../../util/urlHelpers';
import {
  deleteCartItem,
  initiateCartCheckout,
  moveToWishlist,
  toggleSelectAllItems,
  updateAllCartItemsCheckoutStatus,
  updateCartItemSelection,
  updateItemQty,
  updateSelectionSuccess,
} from './CartPage.duck';
import classNames from 'classnames';
import { ReactComponent as DeleteIcon } from '../../assets/svg/delete.svg';
import { ReactComponent as PlusIcon } from '../../assets/svg/plus.svg';
import { ReactComponent as MinusIcon } from '../../assets/svg/minus.svg';
import { ReactComponent as ThreeDotIcon } from '../../assets/svg/threeDot.svg';
import { IoMdInformationCircleOutline } from 'react-icons/io';
import { createResourceLocatorString, findRouteByRouteName } from '../../util/routes';
import { useRouteConfiguration } from '../../context/routeConfigurationContext';
import BackButton from '../../components/Button/BackButton';
import routeConfiguration from '../../routing/routeConfiguration';
import { updateSearchPageWindowFlag } from '../SearchPage/helper';
import Loader from '../../components/Loader/Loader';
import { BiHeart, BiSolidHeart } from 'react-icons/bi';
import { MdOutlineCheckBox } from 'react-icons/md';
import { MdOutlineCheckBoxOutlineBlank } from 'react-icons/md';
import { FaCheck } from 'react-icons/fa6';

const cardRenderSizes = isMapVariant => {
  if (isMapVariant) {
    // Panel width relative to the viewport
    const panelMediumWidth = 50;
    const panelLargeWidth = 62.5;
    return [
      '(max-width: 767px) 100vw',
      `(max-width: 1023px) ${panelMediumWidth}vw`,
      `(max-width: 1920px) ${panelLargeWidth / 2}vw`,
      `${panelLargeWidth / 3}vw`,
    ].join(', ');
  } else {
    // Panel width relative to the viewport
    const panelMediumWidth = 50;
    const panelLargeWidth = 62.5;
    return [
      '(max-width: 549px) 100vw',
      '(max-width: 767px) 50vw',
      `(max-width: 1439px) 26vw`,
      `(max-width: 1920px) 18vw`,
      `14vw`,
    ].join(', ');
  }
};

const CartItemComponent = props => {
  const {
    item: cartItem,
    index,
    totalItemCount,
    isSelected,
    handleChange,
    handleDelete,
    handleMoveToWishlist,
    handleUpdateItemQty,
    intl,
    config,
    renderSizes,
  } = props;
  const [state, setState] = useState({ showMoveToWishlistBtn: false });
  const divRef = useRef(null);
  const item = cartItem.listing;
  if (!item) {
    return null;
  }
  const qty = cartItem.qty;
  const outOfStock = cartItem.outOfStock;
  const unavailable = cartItem.unavailable;
  const maxQty = item.currentStock.attributes.quantity;
  const isLast = index === totalItemCount - 1;
  const publicData = item.attributes?.publicData;
  const author = item.author;
  const profileUrl =
    author.attributes.profile.publicData?.rawProfileUrl ||
    author.attributes.profile.publicData?.profileUrl;
  const sizeKey = Object.keys(publicData).find(key => /^.*(size).*$/i.test(key));
  const sizeValue = publicData[sizeKey] || null;
  const brand = config.customListingField.brand?.[publicData.brand]?.label || publicData?.brand;
  const size = config.customListingField?.[sizeKey]?.[sizeValue]?.label || 'Unknown';
  const storeName = <span className={css.cardOptionLabel}>{profileUrl}</span>;
  const DeleteIconComp = qty < 2 ? DeleteIcon : MinusIcon;
  const hasMaxQtyReached = qty >= maxQty;
  const id = item.id.uuid;

  const onUpdateItemQty = e => {
    e.preventDefault();
    const newQty = qty + 1;
    if (newQty > maxQty) {
      return;
    }
    handleUpdateItemQty(qty + 1);
  };

  const deleteOrUpdateQty = e => {
    e.preventDefault();
    const newQty = qty - 1;
    if (newQty < 1) {
      handleDelete();
      return;
    }
    handleUpdateItemQty(newQty);
    return;
  };

  const closeMoveToWishlistModal = () => {
    setState({ showMoveToWishlistBtn: false });
  };

  const toggleMoveToWishlistModal = e => {
    e.preventDefault();
    setState(state => ({ ...state, showMoveToWishlistBtn: !state.showMoveToWishlistBtn }));
  };
  const handleBlur = e => {
    if (!divRef.current) {
      return;
    }
    if (!divRef.current.contains(e.relatedTarget)) {
      closeMoveToWishlistModal();
    }
  };

  return (
    <React.Fragment>
      <div className={css.cartItemContainer}>
        <label
          htmlFor={id}
          className={classNames(css.checkboxInput, css.cartItemCheckbox, {
            [css.checkedInput]: isSelected,
          })}
        >
          <input type="checkbox" checked={isSelected} onChange={handleChange} id={id} />
          {isSelected ? <FaCheck /> : null}
        </label>
        {/* <input
          className={classNames(css.checkboxInput, css.cartItemCheckbox)}
          type="checkbox"
          checked={isSelected}
          onChange={handleChange}
        /> */}
        {/* <div
          className={css.checkboxInput} // or a new class like css.itemCheckboxIcon
          onClick={() => handleChange({ target: { checked: !isSelected } })}
          role="checkbox"
          aria-checked={isSelected}
          tabIndex={0}
          onKeyDown={e => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              handleChange({ target: { checked: !isSelected } });
            }
          }}
        >
          {isSelected ? <MdOutlineCheckBox /> : <MdOutlineCheckBoxOutlineBlank />}
        </div> */}

        <div className={css.imageContentContainer}>
          <ImageVideoPreview
            listing={item}
            config={config}
            renderSizes={renderSizes}
            className={css.imageVideoContainer}
            imageClassName={css.imageRoot}
            videoPlayerClassName={css.videoPlayer}
          />
          {unavailable ? (
            <span className={classNames(css.soldOutLabel, css.unavailableLabel)}>
              {intl.formatMessage({ id: 'unavailable' })}
            </span>
          ) : outOfStock ? (
            <span className={css.soldOutLabel}>{intl.formatMessage({ id: 'soldOut' })}</span>
          ) : null}
        </div>
        <div className={css.contentContainer}>
          <div className={css.itemDetails}>
            <div className={css.titleContainer}>
              <NamedLink
                name="ListingPage"
                params={{ id: item.id.uuid, slug: createSlug(item.attributes.title) }}
                className={css.cartTitle}
              >
                {item?.attributes?.title}
              </NamedLink>
              <div className={css.titleAction} tabIndex={0} onBlur={handleBlur} ref={divRef}>
                {/* <InlineTextButton
                  type="button"
                  onClick={toggleMoveToWishlistModal}
                  className={css.threeDotBtn}
                >
                  <ThreeDotIcon />
                </InlineTextButton>
                {state.showMoveToWishlistBtn ? (
                  <PrimaryButton
                    className={css.moveToWishListBtnMobile}
                    onClick={handleMoveToWishlist}
                    type="button"
                  >
                    <FormattedMessage id="moveToWishlist" />
                  </PrimaryButton>
                ) : null} */}
                <button
                  type="button"
                  className={css.like} // Add proper styling
                  onClick={handleMoveToWishlist} // Already passed from props
                >
                  {cartItem.liked ? <BiSolidHeart /> : <BiHeart />}
                </button>
              </div>
            </div>
            <div className={css.priceValMobileCont}>
              <PriceMaybe
                intl={intl}
                price={item?.attributes?.price}
                publicData={publicData}
                config={config}
                className={css.priceValMobile}
              />
            </div>
            <p className={css.storeName}>
              <FormattedMessage id="customSliderCard.storeName" values={{ storeName }} />
            </p>
            <p className={css.brandText}>{brand}</p>
            {/* <p>
              <FormattedMessage
                id="CartPage.color"
                values={{ color: <span className={css.colorText}>{publicData.color}</span> }}
              />
            </p> */}

            {size && (
              <p className={css.sizeText}>
                <FormattedMessage id="CartPage.size" values={{ size: size }} />
              </p>
            )}

            <div className={css.perItemCta}>
              <div className={css.countActionBtnContainer}>
                <InlineTextButton onClick={deleteOrUpdateQty} type="button">
                  <DeleteIconComp className={css.deleteIcon} />
                </InlineTextButton>
                <span className={css.countText}>{qty}</span>
                <InlineTextButton
                  disabled={hasMaxQtyReached}
                  onClick={onUpdateItemQty}
                  type="button"
                >
                  <PlusIcon />
                </InlineTextButton>
              </div>
              <SecondaryButton onClick={handleDelete} className={css.itemDeleteBtn} type="button">
                <FormattedMessage id="delete" />
              </SecondaryButton>
              <PrimaryButton
                className={css.moveToWishListBtn}
                onClick={handleMoveToWishlist}
                type="button"
              >
                <FormattedMessage id="moveToWishlist" />
              </PrimaryButton>
            </div>
          </div>

          <PriceMaybe
            intl={intl}
            price={item?.attributes?.price}
            publicData={publicData}
            config={config}
            className={css.priceVal}
          />
        </div>
      </div>
      {!isLast && <hr className={css.divider} />}
    </React.Fragment>
  );
};

class CartPageComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedItems: [],
    };

    this.toggleSelectAll = this.toggleSelectAll.bind(this);
  }

  // toggleSelectAll() {
  //   const { cartItems } = this.props;
  //   const { selectedItems } = this.state;
  //   if (selectedItems.length === cartItems.length) {
  //     // Deselect all
  //     this.setState({ selectedItems: [] });
  //   } else {
  //     const allItemIds = cartItems.map(item => item.id.uuid);
  //     this.setState({ selectedItems: allItemIds });
  //   }
  // }

  toggleSelectAll() {
    const { cartItems, onToggleSelectAll } = this.props;
    const allSelected = cartItems.every(item => item.isSelectedForCheckout);
    onToggleSelectAll(!allSelected); // toggle opposite
  }

  handleMoveToWishlist = (id, config) => () => {
    const { onMoveToWishlist } = this.props;
    onMoveToWishlist(id, config);
  };

  handleUpdateItemQty = ({ id, index, config }) => qty => {
    const { onUpdateItemQty } = this.props;
    onUpdateItemQty({ id, qty, index, config });
  };

  handleInitiateCheckout = noItemForCheckout => async e => {
    e.preventDefault();
    if (noItemForCheckout) {
      return;
    }
    const {
      onInitiateCheckout,
      onUpdateSelectionSuccess,
      routes,
      history,
      callSetInitialValues,
      cartItems,
    } = this.props;

    const firstItem = cartItems.find(item => !item.outOfStock && !item.unavailable);
    if (!firstItem) {
      return;
    }
    await onInitiateCheckout();
    const listing = firstItem.listing;
    const quantityMaybe = Number.isInteger(firstItem.qty) ? { quantity: firstItem.qty } : {};
    const deliveryMethodMaybe = { deliveryMethod: 'shipping' };
    const initialValues = {
      listing,
      orderData: {
        ...quantityMaybe,
        ...deliveryMethodMaybe,
      },
      confirmPaymentError: null,
    };

    const saveToSessionStorage = true;

    // Customize checkout page state with current listing and selected orderData
    const { setInitialValues } = findRouteByRouteName('CheckoutPage', routes);
    callSetInitialValues(setInitialValues, initialValues, saveToSessionStorage);

    onUpdateSelectionSuccess();
    // Redirect to CheckoutPage
    history.push(
      createResourceLocatorString(
        'CheckoutPage',
        routes,
        { id: listing.id.uuid, slug: createSlug(listing.attributes.title) },
        {}
      )
    );
  };

  render() {
    const {
      cartItems,
      cartFetchInProgress,
      totalCartItems,
      intl,
      config,
      onUpdateCartItemForSelection,
      updatingSelection,
      checkOutData,
      onHandleDelete,
      totalOutOfStockListing,
      routes,
      history,
    } = this.props;
    const { Money } = sdkTypes;
    const {
      totalItems: totalCartItemsForCheckout,
      totalPrice: totalPriceForCheckout,
    } = checkOutData;

    const noItemForCheckout = totalCartItemsForCheckout < 1;

    const allSelected = cartItems.length > 0 && cartItems.every(i => i.isSelectedForCheckout);

    const formattedCheckoutPrice =
      totalPriceForCheckout !== null
        ? new Money(totalPriceForCheckout, config.currency)
        : new Money(0, config.currency);
    const renderSizes = cardRenderSizes(false);

    return (
      <Page rootClassName={css.root} title={intl.formatMessage({ id: 'CartPage.title' })}>
        <TopbarContainer />
        <div role="main" className={css.main}>
          <H4 as="h1" className={css.title}>
            <div className={css.backBtnContainer}>
              <BackButton />
            </div>
            <FormattedMessage
              id={cartFetchInProgress ? 'CartPage.title' : 'CartPage.titleCount'}
              values={{ count: totalCartItems }}
            />
          </H4>
          {cartFetchInProgress ? (
            <div className={css.spinnerContainer}>
              {/* <IconSpinner rootClassName={css.spinner} /> */}
              <Loader />
            </div>
          ) : cartItems.length ? (
            <div className={classNames(css.mainContainer, { [css.fetching]: updatingSelection })}>
              <div className={css.cartItemsContainer}>
                <div className={css.selectAllRow}>
                  <label
                    className={classNames(css.checkboxInput, {
                      [css.checkedInput]: allSelected,
                    })}
                  >
                    <input type="checkbox" checked={allSelected} onChange={this.toggleSelectAll} />
                    {/* <div
                      // className={css.selectAllIcon}
                      className={css.checkboxInput}
                      onClick={this.toggleSelectAll}
                      // role="checkbox"
                      aria-checked={allSelected}
                      // tabIndex={0}
                      onKeyDown={e => {
                        if (e.key === 'Enter' || e.key === ' ') {
                          e.preventDefault();
                          this.toggleSelectAll();
                        }
                      }}
                    >
                    </div> */}
                    {allSelected ? <FaCheck /> : null}
                  </label>
                  <FormattedMessage id="CartPage.selectAll" />
                </div>
                {cartItems.map((item, index) => (
                  <CartItemComponent
                    key={item.id}
                    item={item}
                    index={index}
                    totalItemCount={totalCartItems}
                    intl={intl}
                    config={config}
                    isSelected={item.isSelectedForCheckout}
                    renderSizes={renderSizes}
                    handleChange={e =>
                      onUpdateCartItemForSelection(item.listingId, e.target.checked, item.id)
                    }
                    handleMoveToWishlist={this.handleMoveToWishlist(item.id, config)}
                    handleDelete={() => onHandleDelete(item.listingId, config)}
                    handleUpdateItemQty={this.handleUpdateItemQty({ id: item.id, index, config })}
                  />
                ))}
              </div>
              <div className={css.rightContainer}>
                <div className={css.sideCard}>
                  <div className={css.breakdownContainer}>
                    <p className={css.myOrderTitle}>{intl.formatMessage({ id: 'myOrder' })}</p>
                    <div className={css.subTotalCont}>
                      <span className={css.subTotalContLabel}>
                        {intl.formatMessage({ id: 'OrderBreakdown.subTotal' })}
                      </span>
                      <PriceMaybe
                        intl={intl}
                        price={formattedCheckoutPrice}
                        // publicData={publicData}
                        config={config}
                        className={css.subtotalPrice}
                      />
                    </div>
                    <p className={css.subTotalCont}>
                      <span className={css.subTotalContLabel}>
                        {intl.formatMessage({ id: 'OrderBreakdown.shippingFee' })}
                      </span>
                      <span
                        className={classNames(css.fee, css.tooltipWrapper)}
                        data-tooltip={intl.formatMessage({ id: 'shippingFeeTbd' })}
                      >
                        <IoMdInformationCircleOutline />
                        {intl.formatMessage({ id: 'tbd' })}
                      </span>
                    </p>
                    <div className={css.grandTotalCont}>
                      <span className={css.grandTotalContLabel}>
                        {intl.formatMessage({ id: 'OrderBreakdown.grandTotal' })}
                      </span>
                      <PriceMaybe
                        intl={intl}
                        price={formattedCheckoutPrice}
                        // publicData={publicData}
                        config={config}
                        className={css.grandTotalPrice}
                      />
                    </div>
                  </div>
                  <div className={css.actionContainer}>
                    {noItemForCheckout && totalOutOfStockListing > 0 ? (
                      <p className={css.orderError}>
                        <FormattedMessage id="CheckoutPageWithInquiryProcess.soldMessageInfo" />
                      </p>
                    ) : null}
                    <PrimaryButton
                      // disabled={noItemForCheckout}
                      // disabled={true}
                      disabled={process.env.LISTING_BYPASS === 'true'}
                      className={css.buyBtn}
                      onClick={this.handleInitiateCheckout(noItemForCheckout)}
                    >
                      <FormattedMessage
                        id="CartPage.proceedToBuy"
                        values={{ purchased: totalCartItemsForCheckout, total: totalCartItems }}
                      />
                    </PrimaryButton>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <p className={css.cartEmptyContainer}>
              <FormattedMessage id="cartPage.noCartItem" />
              <PrimaryButton
                onClick={() => {
                  updateSearchPageWindowFlag({ preventLoading: false });
                  history.push(createResourceLocatorString('SearchPage', routes, {}, {}));
                }}
              >
                {intl.formatMessage({ id: 'CartPage.startShoppingCta' }).toUpperCase()}
              </PrimaryButton>
            </p>
          )}
        </div>
        <FooterComponent />
      </Page>
    );
  }
}

const mapStateToProps = state => {
  const {
    listings,
    fetchInProgress,
    totalCartItems,
    updatingSelection,
    checkOutData,
    totalOutOfStockListing,
  } = state.CartPage;
  return {
    cartItems: listings,
    cartFetchInProgress: fetchInProgress,
    totalCartItems,
    updatingSelection,
    checkOutData,
    totalOutOfStockListing,
  };
};

const mapDispatchToProps = dispatch => ({
  onUpdateCartItemForSelection: (listingId, isSelected, id) =>
    dispatch(updateCartItemSelection(listingId, isSelected, id)),
  onToggleSelectAll: isSelectAll => dispatch(updateAllCartItemsCheckoutStatus(isSelectAll)),
  onHandleDelete: (listingId, config) => dispatch(deleteCartItem(listingId, config)),
  onMoveToWishlist: (id, config) => dispatch(moveToWishlist(id, config)),
  onUpdateItemQty: ({ id, qty, index, config }) =>
    dispatch(updateItemQty({ id, qty, index, config })),
  onInitiateCheckout: () => dispatch(initiateCartCheckout()),
  onUpdateSelectionSuccess: () => dispatch(updateSelectionSuccess()),
  callSetInitialValues: (setInitialValues, values, saveToSessionStorage) =>
    dispatch(setInitialValues(values, saveToSessionStorage)),
});

const EnhancedCartPage = props => {
  const config = useConfiguration();
  const routes = useRouteConfiguration();
  const intl = useIntl();
  return <CartPageComponent config={config} intl={intl} {...props} routes={routes} />;
};

const CartPage = compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(EnhancedCartPage);
export default CartPage;
